import config from 'Config';

function getLoginUrl() {
    return config.loginUrl;
}

export default getLoginUrl;
